import Form from "components/Forms/Form";
import Input from "components/Forms/Input";
import Location from "components/Forms/Location";
import { Modal, ModalColumn } from "components/Modal";
import { FieldState, FormState } from "formstate";
import { required } from "helpers/FormValidation";
import { useState } from "react";
import { categoryStore, DocumentTypeContractTypeEnum, languageStore, MainCategoryInterface, navigationStore } from "stores";

interface Props {
    contractType: DocumentTypeContractTypeEnum
}

const AddCategoryModal = (props: Props) => {
    const [showModal, setShowModal] = useState(false);

    const form = new FormState({
        name: new FieldState('').validators(required),
        locationId: new FieldState('').validators(required)
    })

    const onSubmit = async () => {
        const category = {
            name: form.$.name.$,
            locationId: form.$.locationId.$,
            contractType: props.contractType
        } as MainCategoryInterface

        const res = await categoryStore.createCategory(category) as MainCategoryInterface;

        form.reset();
        setShowModal(false);
        navigationStore.push(`/admin/categories/${res.id}`);
    }

    return (
        <div className='text-left'>
            <button onClick={() => setShowModal(true)} className='bg-comablue-label text-white py-2 px-8 rounded'>
                {languageStore.get('add')}
            </button>
            {
                showModal &&
                <Form onValidSubmit={onSubmit} formState={form}>
                    <Modal
                        title={languageStore.get('category')}
                        primaryButton={{ title: languageStore.get('save') }}
                        secondaryButton={{ title: languageStore.get('cancel'), onClick: () => setShowModal(false) }}>

                        <ModalColumn>

                            <Input
                                fieldState={form.$.name}
                                id='category'
                                label={languageStore.get('name')} />

                            <Location
                                fieldState={form.$.locationId}
                                editMode={true}
                            />

                        </ModalColumn>

                    </Modal>
                </Form>
            }
        </div>
    )
}

export default AddCategoryModal;

